import { useToggle } from 'modules/utils/useToggle';
import { FunnelIcon } from '@heroicons/react/24/outline';
import { BalanceFilterModal } from './BalanceFilterModal';
import { PnlFilterModal } from './PnlFilterModal';
import { LabelsFilterModal } from './LabelsFilterModal';
import { useWalletsSearchFilters } from './usePageParams';
import { FilterButton } from '../../../components/filters/filterButton';
import { Chains } from 'api/types/httpsTypes/d-wallets';

export function LabelsFilter() {
  const [isOpen, { open, close }] = useToggle();
  const { filtersState } = useWalletsSearchFilters();

  return (
    <>
      <FilterButton label="Labels" onClick={() => open()}>
        {!!filtersState.tradingStyle && (
          <FunnelIcon className="w-3 h-3 xxs:text-dex-white-secondary" />
        )}
      </FilterButton>
      {isOpen && <LabelsFilterModal handleClose={close} />}
    </>
  );
}

export function BalanceRangeFilter() {
  const [isOpen, { open, close }] = useToggle();
  const { filtersState } = useWalletsSearchFilters();

  return (
    <>
      <FilterButton label="Balance Range" onClick={() => open()}>
        {!!(filtersState.minBalance || filtersState.maxBalance) && (
          <FunnelIcon className="w-3 h-3 xxs:text-dex-white-secondary" />
        )}
      </FilterButton>
      {isOpen && <BalanceFilterModal handleClose={close} />}
    </>
  );
}

export function PnlFilter({ chain }: { chain: Chains }) {
  const [isOpen, { open, close }] = useToggle();
  const { filtersState } = useWalletsSearchFilters();
  return (
    <>
      <FilterButton label="PnL Range" onClick={() => open()}>
        {!!(filtersState.minPnl || filtersState.maxPnl) && (
          <FunnelIcon className="w-3 h-3 xxs:text-dex-white-secondary" />
        )}
      </FilterButton>
      {isOpen && <PnlFilterModal handleClose={close} chain={chain} />}
    </>
  );
}
